"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetPostcodeLocationPostcodesPostcodeLocationGetRequest$ = exports.GetPostcodeLocationPostcodesPostcodeLocationGetRequest$outboundSchema = exports.GetPostcodeLocationPostcodesPostcodeLocationGetRequest$inboundSchema = exports.GetPostcodeLocationPostcodesPostcodeLocationGetSecurity$ = exports.GetPostcodeLocationPostcodesPostcodeLocationGetSecurity$outboundSchema = exports.GetPostcodeLocationPostcodesPostcodeLocationGetSecurity$inboundSchema = void 0;
exports.getPostcodeLocationPostcodesPostcodeLocationGetSecurityToJSON = getPostcodeLocationPostcodesPostcodeLocationGetSecurityToJSON;
exports.getPostcodeLocationPostcodesPostcodeLocationGetSecurityFromJSON = getPostcodeLocationPostcodesPostcodeLocationGetSecurityFromJSON;
exports.getPostcodeLocationPostcodesPostcodeLocationGetRequestToJSON = getPostcodeLocationPostcodesPostcodeLocationGetRequestToJSON;
exports.getPostcodeLocationPostcodesPostcodeLocationGetRequestFromJSON = getPostcodeLocationPostcodesPostcodeLocationGetRequestFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
/** @internal */
exports.GetPostcodeLocationPostcodesPostcodeLocationGetSecurity$inboundSchema = z.object({
    Bearer: z.string().optional(),
    "X-API-KEY": z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "Bearer": "bearer",
        "X-API-KEY": "xApiKey",
    });
});
/** @internal */
exports.GetPostcodeLocationPostcodesPostcodeLocationGetSecurity$outboundSchema = z.object({
    bearer: z.string().optional(),
    xApiKey: z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        bearer: "Bearer",
        xApiKey: "X-API-KEY",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var GetPostcodeLocationPostcodesPostcodeLocationGetSecurity$;
(function (GetPostcodeLocationPostcodesPostcodeLocationGetSecurity$) {
    /** @deprecated use `GetPostcodeLocationPostcodesPostcodeLocationGetSecurity$inboundSchema` instead. */
    GetPostcodeLocationPostcodesPostcodeLocationGetSecurity$.inboundSchema = exports.GetPostcodeLocationPostcodesPostcodeLocationGetSecurity$inboundSchema;
    /** @deprecated use `GetPostcodeLocationPostcodesPostcodeLocationGetSecurity$outboundSchema` instead. */
    GetPostcodeLocationPostcodesPostcodeLocationGetSecurity$.outboundSchema = exports.GetPostcodeLocationPostcodesPostcodeLocationGetSecurity$outboundSchema;
})(GetPostcodeLocationPostcodesPostcodeLocationGetSecurity$ || (exports.GetPostcodeLocationPostcodesPostcodeLocationGetSecurity$ = GetPostcodeLocationPostcodesPostcodeLocationGetSecurity$ = {}));
function getPostcodeLocationPostcodesPostcodeLocationGetSecurityToJSON(getPostcodeLocationPostcodesPostcodeLocationGetSecurity) {
    return JSON.stringify(exports.GetPostcodeLocationPostcodesPostcodeLocationGetSecurity$outboundSchema
        .parse(getPostcodeLocationPostcodesPostcodeLocationGetSecurity));
}
function getPostcodeLocationPostcodesPostcodeLocationGetSecurityFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.GetPostcodeLocationPostcodesPostcodeLocationGetSecurity$inboundSchema
        .parse(JSON.parse(x)), `Failed to parse 'GetPostcodeLocationPostcodesPostcodeLocationGetSecurity' from JSON`);
}
/** @internal */
exports.GetPostcodeLocationPostcodesPostcodeLocationGetRequest$inboundSchema = z.object({
    postcode: z.string(),
});
/** @internal */
exports.GetPostcodeLocationPostcodesPostcodeLocationGetRequest$outboundSchema = z.object({
    postcode: z.string(),
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var GetPostcodeLocationPostcodesPostcodeLocationGetRequest$;
(function (GetPostcodeLocationPostcodesPostcodeLocationGetRequest$) {
    /** @deprecated use `GetPostcodeLocationPostcodesPostcodeLocationGetRequest$inboundSchema` instead. */
    GetPostcodeLocationPostcodesPostcodeLocationGetRequest$.inboundSchema = exports.GetPostcodeLocationPostcodesPostcodeLocationGetRequest$inboundSchema;
    /** @deprecated use `GetPostcodeLocationPostcodesPostcodeLocationGetRequest$outboundSchema` instead. */
    GetPostcodeLocationPostcodesPostcodeLocationGetRequest$.outboundSchema = exports.GetPostcodeLocationPostcodesPostcodeLocationGetRequest$outboundSchema;
})(GetPostcodeLocationPostcodesPostcodeLocationGetRequest$ || (exports.GetPostcodeLocationPostcodesPostcodeLocationGetRequest$ = GetPostcodeLocationPostcodesPostcodeLocationGetRequest$ = {}));
function getPostcodeLocationPostcodesPostcodeLocationGetRequestToJSON(getPostcodeLocationPostcodesPostcodeLocationGetRequest) {
    return JSON.stringify(exports.GetPostcodeLocationPostcodesPostcodeLocationGetRequest$outboundSchema.parse(getPostcodeLocationPostcodesPostcodeLocationGetRequest));
}
function getPostcodeLocationPostcodesPostcodeLocationGetRequestFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.GetPostcodeLocationPostcodesPostcodeLocationGetRequest$inboundSchema
        .parse(JSON.parse(x)), `Failed to parse 'GetPostcodeLocationPostcodesPostcodeLocationGetRequest' from JSON`);
}
//# sourceMappingURL=getpostcodelocationpostcodespostcodelocationget.js.map